import React from "react";
import {ActionButton} from "../../../../designSystem/components/ActionButton";
import {Category} from "../../../../types/Post";

interface NextLevelCategoryListProps {
  categories: Category[];
  onNavigate: (id: string) => void;
}

export const NextLevelCategoryList = ({
  categories,
  onNavigate,
}: NextLevelCategoryListProps) => (
  <div className="p-2 overflow-x-auto">
    <div className="flex space-x-3 min-w-max">
      {categories.map((category) => (
        <ActionButton
          key={category.id}
          label={category.name}
          onClick={() => onNavigate(category.id)}
          variant="outline"
        />
      ))}
    </div>
  </div>
);